interface BrokenRuleType {
  code: string;
  message: string;
}

export class BrokenRule implements BrokenRuleType {
  code: string;
  message: string;

  constructor(data?: BrokenRuleType) {
    this.code = "";
    this.message = "";
    data && Object.assign(this, data);
  }
}

export interface ETarResultType {
  brokenRules: BrokenRuleType[];
  error?: string;
}

export class ETarResult implements ETarResultType {
  brokenRules: BrokenRule[];
  error?: string;

  constructor(data?: ETarResultType) {
    this.brokenRules = [];
    data && Object.assign(this, data);
    data && data.brokenRules && data.brokenRules.map(it => new BrokenRule(it));
  }
}

export const mapToETarResult = (data: any): ETarResult => {
  const eTarResult = new ETarResult();
  if (data.Msg != null) {
    eTarResult.error = data.Msg;
    return eTarResult;
  }

  if (data && data.Result && data.Result.registeredItems) {
    data.Result.Result.forEach((it: any) => {
      if (!(it.BrokenRules && it.BrokenRules.length === 0)) {
        it.BrokenRules.forEach((brokenRule: any) => {
          const rule = new BrokenRule();
          rule.code = brokenRule.code;
          rule.message = brokenRule.error;
          eTarResult.brokenRules = eTarResult.brokenRules.concat(rule);
        });
      }
    });
  }

  return eTarResult;
};
